import { setActiveInterval } from '../../utils/setActiveInterval'
import md5 from 'md5'

const asyncFetch = (nuxtApp) => {
  return async function (method, args, options = {}, callbacks = {}) {
    const defaultCallbacks = {
      onStatus () {},
      onSuccess () {},
      onFail () {},
      onStart () {},
      onEnd () {},
      onKill () {}
    }
    const { onStatus, onSuccess, onFail, onStart, onEnd, onKill } = { ...defaultCallbacks, ...callbacks }
    const fetchStartEvent = {}
    onStart(fetchStartEvent)
    const { $res, $bugsnag, $confirm, $toast } = nuxtApp
    const intervalTime = options.intervalTime || 1000
    const maxAttempts = options.maxAttempts || 120
    const secondsBeforeEmail = options.secondsBeforeEmail || 30
    const asyncResponse = await method.apply(this, args)
    let lastResponseHash
    let attempts = 0
    let illWait = false
    const startTime = new Date().getTime()

    // Start Poller Interval

    if (asyncResponse) {
      const poller = setActiveInterval(async () => {
        attempts += 1
        console.log(attempts)
        const response = await $res.fetch.asyncGet(asyncResponse)
        const responseHash = response ? md5(JSON.stringify(response)) : null
        const fail = (reason) => {
          clearInterval(poller)
          onEnd()
          onFail(reason)
          delete fetchStartEvent.kill
        }

        // INVALID RESPONSE

        if (responseHash === null) {
          $bugsnag(new Error('Invalid response from async/get'), {
            metadata: {
              response,
              payload: asyncResponse
            }
          })
          fail('Invalid response from async/get')
        }

        // SUCCESS
        else if (response?.complete) {
          clearInterval(poller)
          let eventData = response.result
          let fileFail
          if (options.file) {
            eventData = await $res.fetch.asyncFetchFileResource(response.result)
            if (!eventData) {
              fail('failed to fetch file after polling had finished')
              fileFail = true
            }
          }
          if (options.sendRawObjects) {
            eventData = response
          }
          if (!fileFail) {
            onSuccess(eventData)
          }
          delete fetchStartEvent.kill
          onEnd()
        }

        // ERROR FOR ORPHANED JOB
        else if (response?.found === false) {
          fail('Polling object not found. Aborting.')
        }

        // REACHED MAX ATTEMPTS
        else if (attempts >= maxAttempts) {
          fail('EXCEEDED_ALLOWED_ATTEMPTS', `Attempted to make ${maxAttempts} calls without detecting a change. Aborting.`)
        }

        // STATUS
        else if (response?.status && response?.status?.length > 0) {
          const status = options.sendRawObjects ? response : { content: response?.status, length: response?.totalMessageSize || 0 }
          onStatus(status)
        }

        // EMAIL

        const elapsedTime = (new Date().getTime() - startTime) / 1000
        if (options.emailEndpoint && elapsedTime > secondsBeforeEmail && !illWait) {
          const cfm = await $confirm({
            title: 'This is Taking a Long Time',
            text: "If you don't want to wait, we can email the result to you when it's complete.",
            'cancel-title': "I'll Wait",
            'ok-title': 'Email Me'
          })
          if (cfm) {
            const res = await options.emailEndpoint(asyncResponse)
            if (res) {
              clearInterval(poller)
              onSuccess('Delegated to Email')
              onEnd()
              $toast('Email Service Initiated', 'success')
            }
          } else {
            illWait = true
          }
        }

        // INCREMENT
        if (lastResponseHash && lastResponseHash !== responseHash) {
          attempts = 0
        }

        lastResponseHash = responseHash
      }, intervalTime)

      fetchStartEvent.kill = async () => {
        const res = await $res.fetch.asyncKill(asyncResponse)
        onKill(res)
        onEnd()
        clearInterval(poller)
      }
    }

    // End Poller Interval
    else {
      onFail('Could not initiate polling')
      onEnd()
    }
  }
}

export const asyncFetchNuxtInstall = (nuxtApp) => {
  const initialized = asyncFetch(nuxtApp)
  nuxtApp.vueApp.config.globalProperties.$asyncFetch = initialized
  nuxtApp.provide('asyncFetch', initialized)
}
